export default "__VITE_ASSET__B45i_b13__"